var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SingleColumn',{attrs:{"md":"4","offset-md":"4"}},[_c('TwoFASetup',{attrs:{"init-status":_vm.status},on:{"completed":_vm.handleTwoFASetupCompleted}}),_c('PToast',{attrs:{"id":"error-toast"}},[_vm._v(" "+_vm._s(_vm.toastText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }